import * as ramda from 'ramda';

import {sortByPosition} from 'nutshell-core/utils/sorting/sort-by-position';

import type {EmailTemplate} from './types';

export function addReplySubjects(emailTemplates: {[templateId: string]: EmailTemplate}) {
    const sortedTemplates = sortByPosition(emailTemplates);

    return {
        emailSequenceTemplateMessages: ramda.mapObjIndexed((template) => {
            if (!template.sendAsReply) {
                return {
                    ...template,
                    replySubject: undefined,
                };
            }
            const index = sortedTemplates.findIndex((t) => t.id === template.id);
            // Just to be safe.  Technically findIndex might not find it, but always should
            if (index === -1) return template;

            return {
                ...template,
                // Be sure that the first template is never a reply
                sendAsReply: index === 0 ? false : template.sendAsReply,
                replySubject: makeReplySubject(getPreviousRealSubject(sortedTemplates, index)),
            };
        }, emailTemplates),
    };
}

/*
 * This loops backwards through the provided email templates, looking for one
 * that is not a reply, and returns its subject
 */
function getPreviousRealSubject(templates: EmailTemplate[], currentIndex: number) {
    let index = currentIndex;
    let sendAsReply;
    do {
        index--;
        if (!templates[index]) {
            // This happens if the original first, non-send-as-reply email has been
            // deleted.
            return '';
        }
        // @ts-expect-error
        sendAsReply = templates[index].sendAsReply;
    } while (sendAsReply && index > 0);

    // @ts-expect-error
    return templates[index].subject;
}

function makeReplySubject(subject: string) {
    return `Re: ${subject}`;
}
